<template>
<!-- Generator: Adobe Illustrator 19.0.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve">
<g>
	<g>
		<path d="M486.013,132.7c-4.58,0-8.294,3.713-8.294,8.294c0,4.58,3.713,8.294,8.294,8.294c5.183,0,9.4,4.217,9.4,9.4v300.786
			c0,5.183-4.217,9.4-9.4,9.4H61.374c-24.695,0-44.786-20.091-44.786-44.786S36.678,379.3,61.374,379.3
			c4.58,0,8.294-3.713,8.294-8.294V149.287h44.786c4.58,0,8.294-3.713,8.294-8.294c0-4.58-3.713-8.294-8.294-8.294H69.667V34.834
			c0-4.58-3.713-8.294-8.294-8.294C27.532,26.54,0,54.072,0,87.914v336.173c0,33.842,27.532,61.374,61.374,61.374h424.639
			c14.329,0,25.987-11.658,25.987-25.987V158.687C512,144.357,500.342,132.7,486.013,132.7z M16.587,87.914
			c0-21.861,15.747-40.115,36.492-44.016v319.374c-14.311,1.942-27.072,8.836-36.492,18.893V87.914z"/>
	</g>
</g>
<g>
	<g>
		<path d="M379.856,132.7h-141.55c-4.58,0-8.294,3.713-8.294,8.294c0,4.58,3.713,8.294,8.294,8.294h141.55
			c4.58,0,8.294-3.713,8.294-8.294C388.15,136.413,384.437,132.7,379.856,132.7z"/>
	</g>
</g>
<g>
	<g>
		<path d="M386.442,383.663L156.429,82.877c-2.16-2.825-5.883-3.959-9.247-2.818c-3.37,1.139-5.635,4.299-5.635,7.855V388.7
			c0,4.58,3.713,8.294,8.294,8.294h230.013c3.156,0,6.037-1.79,7.436-4.619C388.688,389.546,388.358,386.169,386.442,383.663z
			 M158.134,380.406V112.412L363.07,380.406H158.134z"/>
	</g>
</g>
<g>
	<g>
		<path d="M296.931,339.428l-96.27-125.891c-2.16-2.824-5.881-3.958-9.247-2.818c-3.368,1.14-5.634,4.301-5.634,7.856v125.891
			c0,4.58,3.713,8.294,8.294,8.294h96.27c3.156,0,6.037-1.79,7.436-4.619S298.849,341.935,296.931,339.428z M202.367,336.173
			v-93.099l71.193,93.099H202.367z"/>
	</g>
</g>
<g>
	<g>
		<path d="M458.326,93.679l-17.693-44.233c-1.258-3.148-4.308-5.213-7.7-5.213c-3.392,0-6.441,2.065-7.7,5.213L407.54,93.679
			c-0.393,0.981-0.594,2.026-0.594,3.081V415.24c0,9.452,7.689,17.14,17.14,17.14h17.693c9.452,0,17.14-7.689,17.14-17.14V96.76
			C458.92,95.705,458.719,94.66,458.326,93.679z M432.933,74.858l8.982,22.455H423.95L432.933,74.858z M442.333,415.24
			c0,0.305-0.248,0.553-0.553,0.553h-17.693c-0.305,0-0.553-0.248-0.553-0.553v-18.246h18.799V415.24z M442.333,380.406h-18.799
			V113.901h18.799V380.406z"/>
	</g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
</svg>
</template>
